import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-toolbox';
import S from '../styles.scss';

const STATE_CHIPS = {
  auto_applied: 'LINKED BY SPOTBOT',
  accepted: 'LINKED',
  edited: 'EDITED',
  rejected: 'DISMISSED',
};

const percent = confidence => (confidence ? `${Math.round(confidence * 100)}%` : '—');

// M5: SPOTBOT's ranked Assessment-link candidates. Accepting links the phases server-side
// through the proposal endpoint (the pipeline's single write path) — no separate relate call.
const AssessmentLinkSuggestions = ({ proposals, onResolve }) => {
  if (proposals.length === 0) return null;
  return (
    <div className={S.spotbotSuggestions}>
      <h5>SPOTBOT: Likely Matching Assessments</h5>
      {proposals.map(proposal => (
        <div key={proposal.id} className={S.suggestionRow}>
          <div className={S.suggestionInfo}>
            <span className={S.suggestionTitle}>
              {`${proposal.proposed_value.customer_name} — Project #`}
              {`${proposal.proposed_value.project_number || 'unknown'} `}
              {`(${percent(proposal.confidence)} match)`}
            </span>
            <span className={S.suggestionReason}>{proposal.rationale}</span>
          </div>
          {STATE_CHIPS[proposal.state] ? (
            <span className={S.appliedChip}>{STATE_CHIPS[proposal.state]}</span>
          ) : (
            <div className={S.suggestionActions}>
              <Button
                label="Link" flat inverse ripple className={S.saveButton}
                onClick={() => onResolve(proposal, 'accepted')}
              />
              <Button
                label="Dismiss" flat ripple
                onClick={() => onResolve(proposal, 'rejected')}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

AssessmentLinkSuggestions.propTypes = {
  proposals: PropTypes.arrayOf(PropTypes.object).isRequired,
  onResolve: PropTypes.func.isRequired,
};

export default AssessmentLinkSuggestions;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseContractVerificationChecklist/components/assessmentLinkSuggestions.jsx